import { ColumnMeta } from '@api/api/screener';

const MultiColumnFilterNameToKeyArray: [RegExp, string][] = [
  [/Return \(%\)/, 'returns'],
  [/Seasonality Returns \(%\)/, 'seasonality_returns'],
  [/^(Change|\d+[WMY]) \(%\)$/, 'returns'],
];

export const getColumnFilterKeyDetails = (meta?: ColumnMeta) => {
  if (!meta) {
    return {
      isMultiColumnFilter: false,
      filterKey: '',
    };
  }

  const { filter, name } = meta;

  const singleColumnFilterKey = filter;
  const multiColumnFilterKey =
    MultiColumnFilterNameToKeyArray.find(([regex]) => regex.test(name))?.[1] ||
    '';
  const filterKey = singleColumnFilterKey || multiColumnFilterKey;

  const isMultiColumnFilter = !filter && !!filterKey;

  return {
    isMultiColumnFilter,
    filterKey,
  };
};
